import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
  Alert,
  Autocomplete,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Pagination,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { AppState } from 'src/store';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import './SivReport.scss';
import Step1SivChecklist from './Step1SivReport';
import Step2SivChecklist from './Step2SivReport';
import Step3SivChecklist from './Step3SivReport';
import { useSivReport } from './useSivReport';
import { archLevel } from 'src/data/config';
import { useMonitoringVisitLog } from '../studyLogs/MonitoringVisitLogs/useMonitoringVisitLog';
import { hideLoader, showLoader } from 'src/store/Loader';
import moment from 'moment';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import { setChckListCMPArr } from 'src/store/sivReport';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { UI_TIME_ZONE } from 'src/constants/formats';
import { useGetAssigneesMutation } from 'src/services/Utils';
import staticData from '../../../resources/static.json';
import { DynamicIcon } from '@pihealth/common-ui-library';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
const steps = ['Step 1', 'Step 2', 'Sign & Submit'];
const SQChecklistPage1: React.FunctionComponent<any> = (props: any) => {
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const { setTabVal, tabVal, tabsData } = useTab();
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const [reviewModelopen, setReviewModelOpen] = React.useState(false);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const { sivcErrorMsg, unSavedWarning } = useFieldTranslation();
  const { user } = useUser();
  const userName = useUser();
  const selectedRowData: any = useAppSelector(state => state.sivReport.selectedRowData);
  const {
    step1SivReport,
    toggle,
    clinicalTrialData,
    updateClinicalData,
    isUpdate,
    setIsUpdate,
    siteAdequacyData,
    updateSiteAdequacyData,
    informedConsentVerificationData,
    keys,
    updateIinformedConsentVerification,
    toggleStep2,
    toggleStep3,
    step2SivReport,
    adverseEventReportingData,
    updateAdverseEventReporting,
    requirementsforEcrfCompletionData,
    sourceDocumentationData,
    updateRequirementsforEcrfCompletion,
    updateSourceDocumentation,
    updateMonitoring,
    monitoringData,
    confirmPageData,
    updateConfirmPage,
    step3SivReport,
    saveDisable,
    setSaveDisable,
    activeStep,
    setActiveStep,
    setSkipped,
    skipped,
    studyId,
    selectedSite,
    selectedCountry,
    getSivReportData,
    sivReportModified,
    setIsChange,
    checkChanged,
    isChanged,
    updateSIVReportMandatoryData,
    mandatory,
    validateMandatory,
    validateMandatoryFields,
    validateMandatoryFieldsForSign,
    sivReportSavedId,
    data,
    isError,
    publishSivReportToEtmf,
    publishSivReportSuccess,
    isPublished,
    sendForReviewFunc,
    notifyUser
  } = useSivReport();

  const { selectedAppSection } = useSelectedAppInfo();
  const [checkedInStartDate, setCheckedInStartDate] = useState<any>(null);
  const { userPreferedDateFormat } = usePreferedDateFormat();

  const { monitoringVisitIsError, monitoringVisitIsLoading, monitoringVisitIsSuccess, getAllMonitoringVisits } =
    useMonitoringVisitLog();
  const [openConfirmExit, setOpenConfirmExit] = useState(false);

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setSkipped(newSkipped);
  };
  const steperPager = (page: number) => {
    setActiveStep(page);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const validateAllAccordionForSign = () => {
    return validateMandatoryFieldsForSign(true);
  };
  const [assigneeList, setAssigneeList] = useState([]);
  const [assigneeValue, setAssigneeValue] = useState<any>();

  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();

  useEffect(() => {
    if (isAssingeeLoading && !isAssingeeSuccess && !isAssingeeError) {
      dispatch(showLoader());
    } else if (!isAssingeeLoading && isAssingeeSuccess) {
      setAssigneeList(assignees);
    }
    dispatch(hideLoader());
  }, [isAssingeeLoading, isAssingeeError, isAssingeeSuccess, assignees]);

  useEffect(() => {
    getAssignees({
      client_name: 'ctms-ui',
      data: ['SIV_CHECKLIST_REVIEWER']
    });
  }, [reviewModelopen]);
  const handleSubmit = () => {
    if (!isChanged && !validateMandatory) {
      if (validateMandatoryFields(true)) {
        setReviewModelOpen(true);
      } else {
        dispatch(setMessage({ msgDetails: 'Missing mandatory information', severity: 'error' }));
      }
    } else if (!isChanged && validateMandatoryFields(true)) {
      setReviewModelOpen(true);
    } else {
      if (isChanged) {
        checkChanged(true);
      }
      if (validateMandatory) {
        validateMandatoryFields(true);
      }
      dispatch(setMessage({ msgDetails: 'Data is modified, please save the changes', severity: 'error' }));
    }
  };
  const handleClose = () => {
    setReviewModelOpen(false);
  };
  const updateSubmitData = async () => {
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: { updated_by: userName.user, siv_report: data, is_submit: false, is_publish: null },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      await sendRequest('update_siv_report', options);

      dispatchApp(
        setMessage({
          msgDetails: `Submitted by ${user} on ${getPreferredDateTimeInLocal(
            moment.utc(new Date()).format().replace('Z', '')
          )}`,
          severity: 'success'
        })
      );
      getSivReportData('isSubmit', false);
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sivcErrorMsg, severity: 'error' }));

      setSaveDisable(false);
    }
  };

  const confirmReview = () => {
    if (assigneeValue && assigneeValue != '') {
      handleConfirmSendForReview();
      setReviewModelOpen(false);
      updateSubmitData();
    } else {
      dispatch(setMessage({ msgDetails: 'Missing mandatory information', severity: 'error' }));
    }
  };
  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const handleNextbtn = (e: any) => {
    const popupShowed = localStorage.getItem('popupShowed');
    if (popupShowed == 'true' && confirmexitpopupval.confirmexitpopupval == true) {
      setConfirmExitPopupVal(dispatch, false);
      setConfirmExitPopupVal(dispatch, true);
    }
    setTabVal(tabVal + 1);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getMonitoringVisitList(studyId, selectedCountry, selectedSite);
  }, [studyId]);

  useEffect(() => {
    if (monitoringVisitIsLoading) {
      dispatch(showLoader());
    } else if (monitoringVisitIsSuccess || monitoringVisitIsError) {
      dispatch(hideLoader());
    }
  }, [monitoringVisitIsLoading, monitoringVisitIsSuccess, monitoringVisitIsError]);

  const getMonitoringVisitList = async (
    studyId: string | null,
    selectedCountry: string | null,
    selectedSite: string | null
  ) => {
    const allMonitoringResponse: any = await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: selectedAppSection
    });
    if (allMonitoringResponse.data && allMonitoringResponse.data.selected_data.length > 0) {
      const sivCheckedInDate: any = allMonitoringResponse?.data?.selected_data.filter(
        (visit: any) => visit.visit_type === 'Site Initiation Visit'
      );

      if (sivCheckedInDate.length && sivCheckedInDate[0].actual_start_date) {
        setCheckedInStartDate(
          moment(`${sivCheckedInDate[0].actual_start_date.replace(' ', 'T')}Z`).format(
            userPreferedDateFormat.toUpperCase()
          )
        );
      } else {
        setCheckedInStartDate(null);
      }
    } else {
      setCheckedInStartDate(null);
    }
  };

  const isUpdatePublish = selectedRowData?.major_version >= 1.0;
  const publishChecklistPermission = checkPermission('publish_siv_checklist_etmf');
  const handlePublishSIVReport = async () => {
    let version = 0.0;
    if (isUpdatePublish) {
      version = Math.floor(selectedRowData?.major_version) + 1;
    } else {
      version = 1.0;
    }
    if (publishChecklistPermission) {
      try {
        dispatch(showLoader());
        await publishSivReportToEtmf({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          monitoring_visit_id: selectedRowData?.id,
          publish_doc_version: version.toFixed(1),
          is_published: true,
          update: isUpdatePublish,
          application: process.env.REACT_APP_NAME,
          application_section: selectedAppSection,
          application_module_section: 'SIV Report'
        });
        dispatch(hideLoader());
      } catch (error: any) {
        dispatch(hideLoader());
        if (error && error?.response?.status === 403) {
          dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
        } else if (error && error.response?.status === 401) {
          dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
        } else {
          dispatch(setMessage({ msgDetails: 'Error while publishing', severity: 'error' }));
        }
      }
    }
  };

  useEffect(() => {
    if (publishSivReportSuccess) {
      dispatchApp(
        setMessage({
          msgDetails: ` ${selectedRowData.visit_name} successfully published to ETMF`,
          severity: 'success'
        })
      );
      getSivReportData('isSubmit', false);
    }
  }, [publishSivReportSuccess]);
  const printSivReport = async () => {
    try {
      dispatch(showLoader());
      const options = {
        monitoring_visit_id: selectedRowData?.id,
        template_name: 'site_initiation_visit_report',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          time_zone_id: UI_TIME_ZONE,
          country: selectedCountry,
          appName: process.env.REACT_APP_NAME
        }
      };
      printPdfWithViewer('get_imvChecklist_pdf_file', options, 'application/pdf');
      setTimeout(() => {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
  };

  const signatureBreaking = async () => {
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      is_submit: false,
      data: {
        updated_by: userName.user,
        monitoring_visit_id: selectedRowData.id,
        notify_user: null,
        siv_report: {
          step_three: {
            confirm: {
              siv_report_prepared_print_name: null,
              siv_report_prepared_signature: null,
              siv_report_prepared_date: null,
              siv_report_reviewed_print_name: null,
              siv_report_reviewed_signature: null,
              siv_report_reviewed_date: null,
              siv_report_approved_print_name: null,
              siv_report_approved_signature: null,
              siv_report_approved_date: null,
              siv_report_additional_comments: null
            }
          }
        }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      const response = await sendRequest('update_siv_report', options);
      if (response) {
        getSivReportData('isSubmit', false);
      }
    } catch (e) {
      setSaveDisable(false);
    }
  };

  const handleConfirmSendForReview = async () => {
    if (assigneeList?.length) {
      const userName = `${assigneeValue.first_name} ${assigneeValue.last_name}`;
      const payload = {
        notify_user: userName,
        updated_by: user
      };
      await sendForReviewFunc({
        site_id: selectedSite,
        study_id: studyId,
        data: payload,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        monitoring_visit_id: selectedRowData.id
      });
    }
  };
  const handelBackButton = () => {
    if (isChanged) {
      setOpenConfirmExit(true);
    } else {
      dispatch(setChckListCMPArr('sivreportview'));
    }
  };
  useEffect(() => {
    return () => {
      handelBackButton();
    };
  }, []);

  return (
    <div className="pi-accordion siv-accordion">
      {(archLevel == 'site' && !isError) || archLevel == 'sponsor' ? (
        <>
          <Grid container mb={1} mt={-1}>
            <Grid item md={12} display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Button
                onClick={handelBackButton}
                key={staticData.sivReportlistView.back_button}
                startIcon={<DynamicIcon name={staticData.sivReportlistView.icon} />}
              >
                {staticData.sivChecklistView.back_button_name}
              </Button>

              <Stack spacing={2} direction="row" justifyContent="space-between">
                {archLevel == 'sponsor' ? (
                  <Button
                    variant="contained"
                    sx={{ textTransform: 'none' }}
                    onClick={handlePublishSIVReport}
                    // variant="contained"
                    disabled={
                      !confirmPageData.siv_report_approved_signature ||
                      !checkPermission('publish_imvchecklist') ||
                      isPublished
                    }
                    style={{ textTransform: 'none' }}
                  >
                    PUBLISH TO eTMF
                  </Button>
                ) : null}
                <IconButton
                  aria-label="Print"
                  color="primary"
                  sx={{ alignSelf: 'center' }}
                  onClick={() => printSivReport()}
                  disabled={!isPublished}
                >
                  <LocalPrintshopIcon />
                </IconButton>
              </Stack>
            </Grid>
          </Grid>
          <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep} className="siv-stepper">
              {steps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: {
                  optional?: React.ReactNode;
                } = {};
                if (isStepOptional(index)) {
                  labelProps.optional = <Typography variant="caption" />;
                }
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps} onClick={() => setActiveStep(index)} style={{ cursor: 'pointer' }}>
                    <StepLabel {...labelProps} style={{ cursor: 'pointer' }}>
                      {label}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {activeStep === 0 ? (
              <>
                {keys !== 0 && (
                  <Step1SivChecklist
                    Step1={sivReportModified.Step1}
                    getSivReportData={getSivReportData}
                    saveDisable={saveDisable}
                    expandedState={step1SivReport}
                    toggle={toggle}
                    clinicalTrialData={clinicalTrialData}
                    updateClinicalData={updateClinicalData}
                    isUpdate={isUpdate}
                    setIsUpdate={setIsUpdate}
                    siteAdequacyData={siteAdequacyData}
                    updateSiteAdequacyData={updateSiteAdequacyData}
                    informedConsentVerificationData={informedConsentVerificationData}
                    updateIinformedConsentVerification={updateIinformedConsentVerification}
                    setIsChange={setIsChange}
                    updateSIVReportMandatoryData={updateSIVReportMandatoryData}
                    mandatory={mandatory}
                    sivReportSavedId={sivReportSavedId}
                    checkedInStartDate={checkedInStartDate}
                    isPublished={isPublished}
                    SignatureBreaking={signatureBreaking}
                  />
                )}
              </>
            ) : activeStep === 1 ? (
              <>
                {keys !== 0 && (
                  <Step2SivChecklist
                    Step2={sivReportModified.Step2}
                    getSivReportData={getSivReportData}
                    saveDisable={saveDisable}
                    toggle={toggleStep2}
                    expandedState={step2SivReport}
                    adverseEventReportingData={adverseEventReportingData}
                    updateAdverseEventReporting={updateAdverseEventReporting}
                    sourceDocumentationData={sourceDocumentationData}
                    updateSourceDocumentation={updateSourceDocumentation}
                    updateMonitoring={updateMonitoring}
                    monitoringData={monitoringData}
                    requirementsforEcrfCompletionData={requirementsforEcrfCompletionData}
                    updateRequirementsforEcrfCompletion={updateRequirementsforEcrfCompletion}
                    isUpdate={isUpdate}
                    setIsChange={setIsChange}
                    updateSIVReportMandatoryData={updateSIVReportMandatoryData}
                    mandatory={mandatory}
                    sivReportSavedId={sivReportSavedId}
                    checkedInStartDate={checkedInStartDate}
                    isPublished={isPublished}
                    SignatureBreaking={signatureBreaking}
                  />
                )}
              </>
            ) : (
              <>
                {keys !== 0 && (
                  <Step3SivChecklist
                    validateAllAccordionForSign={validateAllAccordionForSign}
                    Step3={sivReportModified.Step3}
                    getSivReportData={getSivReportData}
                    saveDisable={saveDisable}
                    toggle={toggleStep3}
                    confirmPageData={confirmPageData}
                    updateConfirmPage={updateConfirmPage}
                    isUpdate={isUpdate}
                    expandedState={step3SivReport}
                    setIsChange={setIsChange}
                    updateSIVReportMandatoryData={updateSIVReportMandatoryData}
                    mandatory={mandatory}
                    sivReportSavedId={sivReportSavedId}
                    checkedInStartDate={checkedInStartDate}
                    isPublished={isPublished}
                    SignatureBreaking={signatureBreaking}
                    notifyUser={notifyUser}
                  />
                )}
              </>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, width: '100%' }} className="siv-pagination">
              <Button disabled={activeStep === 0} onClick={handleBack}>
                <KeyboardArrowLeftIcon fontSize="medium" />
              </Button>
              <Pagination
                style={{ margin: 'auto' }}
                count={steps.length}
                onChange={(event: React.ChangeEvent<unknown>, page: number) => steperPager(page - 1)}
                size="large"
                page={activeStep + 1}
                hidePrevButton
                hideNextButton
              />
              <Button disabled={activeStep === 2} onClick={handleNext}>
                <KeyboardArrowRightIcon fontSize="medium" />
              </Button>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />

              {activeStep === steps.length - 1 &&
                (confirmPageData.siv_report_prepared_signature &&
                !confirmPageData.siv_report_reviewed_signature &&
                !confirmPageData.siv_report_approved_signature ? (
                  <Button
                    disabled={!checkPermission('update_siv_report') || !checkedInStartDate || notifyUser !== null}
                    style={!saveDisable ? { display: 'inline' } : { display: 'none' }}
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{ mr: 2 }}
                  >
                    Send for Review
                  </Button>
                ) : confirmPageData.siv_report_reviewed_signature && !confirmPageData.siv_report_approved_signature ? (
                  <Button
                    //disabled={!checkPermission('update_siv_report') || !checkedInStartDate}
                    disabled
                    style={!saveDisable ? { display: 'inline' } : { display: 'none' }}
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{ mr: 2 }}
                  >
                    Send for Approval
                  </Button>
                ) : confirmPageData.siv_report_approved_signature ? (
                  <Button
                    disabled={!checkPermission('update_siv_report') || !checkedInStartDate}
                    style={{ display: 'none' }}
                    // onClick={handleSubmit}
                    variant="contained"
                    sx={{ mr: 2 }}
                  >
                    Approved
                  </Button>
                ) : (
                  <Button
                    disabled={
                      !checkPermission('update_siv_report') ||
                      !checkedInStartDate ||
                      !confirmPageData.siv_report_prepared_signature
                    }
                    style={!saveDisable ? { display: 'inline' } : { display: 'none' }}
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{ mr: 2 }}
                  >
                    Submit
                  </Button>
                ))}

              <PopupComponent open={reviewModelopen} maxWidth="md">
                <DialogTitle>Confirm</DialogTitle>
                <DialogContent sx={{ minWidth: 400, minHeight: 120 }}>
                  <Autocomplete
                    className="customNamePicker"
                    id="sq-report-user-signature"
                    options={assigneeList}
                    autoComplete
                    // for filtering the autocomplete list with atleast 3 characters
                    getOptionLabel={option => {
                      return `${option?.first_name} ${option?.last_name} (${option?.email})`;
                    }}
                    filterOptions={(options: Array<any>, state: any) => {
                      let filteredOption: any = [];
                      filteredOption = options.filter((item: any) => {
                        const temp = `${item?.first_name} ${item?.last_name} (${item?.email})`;
                        if (state?.inputValue?.length >= 3) {
                          if (
                            temp.toLowerCase() === state?.inputValue.toLowerCase() ||
                            temp.toLowerCase().includes(state?.inputValue.toLowerCase())
                          ) {
                            return item;
                          }
                        }
                      });
                      return filteredOption;
                    }}
                    onChange={(event, newValue) => {
                      setAssigneeValue(newValue);
                    }}
                    value={assigneeValue || null}
                    renderInput={(params: any) => (
                      <TextField
                        error={false}
                        required
                        {...params}
                        label="Notify Users for Review"
                        placeholder="Notify Users for Review"
                        InputLabelProps={{
                          style: {
                            marginLeft: '-10px'
                          }
                        }}
                      />
                    )}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} className="grey-btn">
                    Cancel
                  </Button>
                  <Button onClick={confirmReview} disabled={!assigneeValue}>
                    Ok
                  </Button>
                </DialogActions>
              </PopupComponent>

              <PopupComponent
                open={openConfirmExit}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="confirm-modal"
                child
              >
                <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      setOpenConfirmExit(false);
                    }}
                    className="grey-btn"
                  >
                    Close
                  </Button>
                  <Button
                    onClick={() => {
                      setConfirmExitValue(dispatch, false);
                      dispatch(setChckListCMPArr('sivreportview'));
                      setOpenConfirmExit(false);
                    }}
                  >
                    Ok
                  </Button>
                </DialogActions>
              </PopupComponent>
              {currentTabinfo[0]?.NextButton && (
                <Button onClick={handleNextbtn} variant="contained">
                  {/* {activeStep === steps.length - 1 ? 'Finish' : 'Next'} */}
                  Next
                </Button>
              )}
            </Box>
          </Box>
        </>
      ) : isError ? (
        <>
          <Alert severity="error">Report not yet published by Sponsor</Alert>{' '}
          <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
              {currentTabinfo[0]?.NextButton && (
                <Button onClick={handleNextbtn} variant="contained">
                  Next
                </Button>
              )}
            </Box>{' '}
          </Box>
        </>
      ) : null}
    </div>
  );
};

export default SQChecklistPage1;
